import {SupportedLocales} from '#types/locale.js';

export const audienceBuilderLang = {
  [SupportedLocales.EN]: {
    name: {
      error: {
        taken: {
          message: 'Audience name already exists',
          title: 'Conflict in audience name',
        },
      },
    },
  },
  [SupportedLocales.ES]: {
    name: {
      error: {
        taken: {
          message: 'El nombre de la audiencia ya existe',
          title: 'Conflicto en el nombre de la audiencia',
        },
      },
    },
  },
};
